import { useContext, useEffect, useState } from 'react';
import { APIContext } from '../../../Contexts/APIContext';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import DropDownViewModel from '../../../Utilities/ViewModels/DropDownViewModel';
import TravelPlanTabsV1 from './Version1/TravelPlanTabsV1';
import TravelPlanTabsV2 from './Version2/TravelPlanTabsV2';
import SiteViewModel from '../../ViewModels/SiteViewModel';
import EditControl from '../EditControl';
import AddIcon from '@mui/icons-material/Add';
import Fab from '@mui/material/Fab';
import Tooltip from '@mui/material/Tooltip';

interface IProps {
    id: string;
    hasTravelPlan?: boolean | null;
    reloadSite?: () => void;
}

export default function TravelPlanContainer(props: IProps) {
    const { get, post, showMessage } = useContext(APIContext);

    const [travelPlanTypes, setTravelPlanTypes] = useState<DropDownViewModel[]>([]);
    const [travelPlanTargetGroups, setTravelPlanTargetGroups] = useState<DropDownViewModel[]>([]);
    const [travelPlanVersion, setTravelPlanVersion] = useState<number | null>(null);
    const [site, setSite] = useState<SiteViewModel>(new SiteViewModel());
    const [readOnly, setReadOnly] = useState(true);
    const [creating, setCreating] = useState(false);
    const [createdInEdit, setCreatedInEdit] = useState(false);

    useEffect(() => {
        if (props.id) {
            getValues();
        }
    }, [props.id]);

    const createTravelPlan = async () => {
        setCreating(true);
        await post('TravelPlan', `CreateTravelPlanV2?reference=${props.id}`, {}, (version: number) => {
            setTravelPlanVersion(version);
            setCreatedInEdit(true);
            showMessage('success', 'Travel Plan V2 added successfully');
            props.reloadSite?.();
        });
        setCreating(false);
    };

    const getValues = () => {
        get('TravelPlan', `GetTravelPlanTypes`, setTravelPlanTypes)
        get('TravelPlan', `GetTravelPlanTargetGroups`, setTravelPlanTargetGroups)
        get('TravelPlan', `GetTravelPlanVersion?id=${props.id}`, (version: number | null | undefined) => setTravelPlanVersion(version ?? null))
        get('Site', `GetSite?reference=${props.id}`, setSite)
    }

    return (
        <>
            {travelPlanVersion === null ?
                <>
                    <Typography variant="h6" sx={{ p: 2 }}>
                        {creating ? 'Adding Travel Plan V2...' : 'No Travel Plan is available. Enter edit mode, then select Add.'}
                    </Typography>
                    {props.hasTravelPlan === false && (
                        <>
                            <EditControl readOnly={readOnly} setReadOnly={setReadOnly} showSave={false} />
                            {!readOnly && (
                                <Tooltip title="Add Travel Plan V2">
                                    <Fab
                                        color="primary"
                                        disabled={creating}
                                        onClick={createTravelPlan}
                                        sx={{ position: 'absolute', bottom: 16, right: 16 }}
                                    >
                                        <AddIcon />
                                    </Fab>
                                </Tooltip>
                            )}
                        </>
                    )}
                </>
                :
                <Box width="100%">
                    {travelPlanVersion == 1 &&
                        <TravelPlanTabsV1 typeDropdown={travelPlanTypes} groupDropdown={travelPlanTargetGroups} id={props.id} site={site} />
                    }
                    {travelPlanVersion == 2 &&
                        <TravelPlanTabsV2 typeDropdown={travelPlanTypes} groupDropdown={travelPlanTargetGroups} id={props.id} site={site} startInEdit={createdInEdit} />
                    }
                </Box>
            }
        </>
    );
}
